if (!window.Eurus.loadedScript.includes("main-register.js")) {
  window.Eurus.loadedScript.push("main-register.js");
  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data("xRegisterForm", () => ({
        isLoading: false,
        checkoutUrl: null,
        init() {
          this.initRegisterForm();
          const params = new URLSearchParams(window.location.search);
          this.checkoutUrl = params.get("checkout_url");

          // save store location cookie
          const storeLocation = params.get("store_location");
          if (storeLocation) {
            this._setCookie("store_location", storeLocation, 30);
          }
        },
        initRegisterForm() {
          const self = this;
          const registerForm = document.getElementById('create_customer');
          new TomSelect(registerForm.querySelector("#country"), {
            allowEmptyOption: false,
            maxOptions: 300
          });
      
          new TomSelect(registerForm.querySelector("#gender"), {
            allowEmptyOption: false,
          });
          if (registerForm) {
            registerForm.submit = function () {
              self.handleSubmit(registerForm);
              return ;
            };
          
            registerForm.addEventListener("submit", (e) => {
              e.preventDefault();
              if(!e.target.querySelector(".h-captcha")) {
                self.handleSubmit(e.target);
              }
            });
          }
        },        
        async handleSubmit(form) {
          try {
            this.isLoading = true;
            const formData = new FormData(form);
            const response = await fetch(form.action, {
              method: form.method,
              body: formData,
            });

            if (!response?.url.includes("/account/register")) {
              await this.handleCreateMetafield(formData);
              this.handleSyncToKlaviyo(formData);
              if (this.checkoutUrl) {
                window.location.href = decodeURIComponent(this.checkoutUrl);
                this.isLoading = false;
                return;
              }
              const productRedirectAfterLogin = localStorage.getItem('cdc_product_redirect_after_login');
              if(productRedirectAfterLogin) {
                window.location.href = productRedirectAfterLogin;
                this.isLoading = false;
                return;
              }
              
              setTimeout(() => {
                this.isLoading = false;
                window.location.href = `${window.Shopify.routes?.root}account`;
              } , 500);
            } else {
              const html = await response.text();
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, "text/html");

              const newForm = doc.querySelector(".register-page");
              if (newForm) {
                document.querySelector(".register-page").innerHTML = newForm.innerHTML;
              } else {
                document.body.innerHTML = html;
              }
              this.initRegisterForm();
              const formErrorEl = document.querySelector(".form-error-message");
              const isGuestCheckout = !!formErrorEl?.textContent?.includes(formData.get("customer[email]"));
              if(isGuestCheckout) {
                await this.handleCreateMetafield(formData);
                this.handleSyncToKlaviyo(formData);
              }
              this.handleScrollToTopForm(document.querySelector("#create_customer"));           
              this.isLoading = false;
            }
          } catch (error) {
            console.log(error);
            this.isLoading = false;
          }
        },
        async handleCreateMetafield(formData) {
          const storeLocation = this._getCookie("store_location");
          const response =await fetch("/apps/custom-app/app/update-customer-country-gender-store-metafields", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              email: formData.get("customer[email]"),
              gender: formData.get("gender"),
              country: formData.get("country"),
              storeLocation
            })
          });

          if(response.ok) {
            this._deleteCookie("store_location");
          }
        },
        handleSyncToKlaviyo(formData) {
          window.klaviyo && window.klaviyo.push(['identify', {
            $email: formData.get("customer[email]"),   
              'Gender': formData.get("gender"),
              'Country': formData.get("country")
            }
          ]);
        },
        handleScrollToTopForm(form) {
          if (form) {
            const formTop = form.getBoundingClientRect().top + window.pageYOffset;
            window.scrollTo({
              top: formTop - 120,
              behavior: "smooth"
            });
          }  
        },
        _getCookie(name) {
          const cname = name + "=";
          const decodedCookie = decodeURIComponent(document.cookie);
          const ca = decodedCookie.split(";");
          for (let i = 0; i < ca.length; i++) {
            let c = ca[i].trim();
            if (c.indexOf(cname) === 0) {
              const value = c.substring(cname.length, c.length);
              return value || null;
            }
          }
          return null;
        },
        _setCookie(name, value, days) {
          const d = new Date();
          d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
          const expires = "expires=" + d.toUTCString();
          document.cookie = name + "=" + encodeURIComponent(value) + ";" + expires + ";path=/";
        },
        _deleteCookie(name) {
          document.cookie = name + `=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
        }
      }));
    });
  });
}